import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ClientDashboardRaw = React.lazy(() => import(/* webpackChunkName: "ClientDashboard" */ './ClientDashboard'));
export const ClientDashboard = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(ClientDashboardRaw, null)));
